import { Space, Image as AntImage } from "antd";
import styled from "styled-components";
import { WarningFilled, IMG_QR } from "@assets";

export const RootContainer = styled.div`
  padding: 16px 16px;

  .ant-collapse {
    background-color: #fff;
    border: 1px solid #e1cce0;

    .ant-image {
      margin-bottom: 12px;
    }
  }

  .ant-collapse-header {
    flex-direction: row-reverse;
  }

  .ant-collapse-header-text {
    font-size: 12px;
    font-weight: bold;
  }
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.textColor};
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 12px;
  }
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textColor};
  text-align: center;
  padding: 0px 0px 8px 8px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const SmallText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.dark1};
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 11px;
  }
`;

export const LightText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: #000000;
  text-align: center;
`;

export const AccountNameText = styled(SmallText)`
  color: ${(props) => props.theme.dark1};
  padding: 8px 0px 0px 8px;
  text-align: center;
`;

export const GrayText = styled.span`
  font-size: 12px;
  font-weight: normal;
  color: ${(props) => props.theme.textColor};
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 11px;
  }
`;

export const TypeText = styled.div`
  font-size: 16px;
  color: ${(props) => props.theme.textColor};

  @media screen and (max-width: 325px) {
    font-size: 12px;
  }
`;

export const Container = styled.div`
  padding: 16px 16px;
  border-radius: 12px;
  background-color: ${(props) => props.theme.white};

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Box = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Divider = styled.div`
  width: 1px;
  border-right: 1px solid ${(props) => props.theme.dark4};
  height: 33px;
`;

export const ImageBox = styled.div`
  flex: 1;
  display: flex;
  grid-gap: 16px;
  align-items: center;
  justify-content: flex-start;

  @media screen and (max-width: 325px) {
    grid-gap: 8px;
  }
`;

export const AmountBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  align-items: flex-start;
  justify-content: center;
  padding-left: 20px;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 54px;
  border-radius: 12px;

  @media screen and (max-width: 350px) {
    width: 35px;
  }
  @media screen and (max-width: 325px) {
    width: 30px;
  }
`;

export const TextWrapper = styled.div`
  padding-top: 8px;
  font-size: 12px;
  font-weight: 400px;
  color: #000;
`;

export const AccountInfo = styled(Space)`
  width: 100%;
  margin-top: 7px;
  background: ${(props) => props.theme.background};
  display: flex;
  align-items: center;
  border-radius: 8px;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }

  .ant-space {
    flex-direction: column;
    align-items: flex-start;
  }

  svg {
    width: 24px;
    cursor: pointer;
  }
`;

export const DigitBox = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-gap: 16px;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 0px;
  position: relative;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledInput = styled.input`
  width: 20px !important;
  height: 23px !important;
  border-radius: 5px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "#E1CCE0")} !important;
  font-size: 17px !important;
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 20px !important;
    height: 23px !important;
  }
  @media screen and (max-width: 330px) {
    width: 20px !important;
    height: 20px !important;
  }
`;

export const SlideImage = styled.img.attrs({
  alt: "slide-img",
})`
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
`;

export const SimpleSlideImage = styled.img.attrs({
  alt: "slide-img",
})`
  width: 278px;
  height: 127px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 8px;
`;

export const EmptyBox = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export const EmptyText = styled.div`
  padding: 0 15%;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  color: ${(props) => props.theme.textColor};

  @media screen and (max-width: 360px) {
    padding: 0 12%;
  }
`;

export const WarningImage = styled(WarningFilled)`
  width: 50px;
  height: 50px;
`;

export const Copy = styled.div`
  color: ${(props) => props.theme.primarySolid};
  cursor: pointer;
  font-weight: 700;
  padding-right: 8px;
`;

export const DigitalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DigitalText = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${(props) => props.theme.textColor};
  text-align: center;
`;

export const QRCodeContainer = styled.div`
  width: 100%;
  margin-top: 7px;
  background: #F4EDE2;
  display: flex;
  align-items: center;
  border-radius: 8px;
  gap: 60px;

  padding: 10px 0px;

  @media screen and (max-width: 450px) {
    gap: 0px;
    justify-content: space-between;
  }
`;

export const QRCodeImage = styled(AntImage).attrs({
  alt: "QR",
  src: IMG_QR,
  preview: false,
})`
  width: 42px;
  height: 42px;
  padding-left: 10px;
`;

export const QRCodeText = styled.div`
  color: ${props => props.theme.primarySolid};
  font-size: 12px;
  line-height: 16px;
  padding-right: 10px;
  cursor: pointer;
  font-weight: 900;

  @media screen and (max-width: 350px) {
    font-size: 10px;
  }
`;

export const Wrapper = styled.div`
  min-width: 60px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ScreenShotBox = styled.div`
  margin: 24px 0 0;
`

export const PalePurpleWrapper = styled.div`
  margin: 12px 0 24px;
  padding: 16px;
  border-radius: 5px;
  border: 1px solid var(--PrimaryGradient, #D39118);
  background: var(--White, #FFF);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  svg{
    width: 24px;
    height: 24px;
  }

  @media screen and (max-width: 400px) {
    padding: 12px;
  }
`

export const UploadText = styled.p`
  color: var(--Dark-1, #6C6559);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`

export const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const ColFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

`

export const BlackText = styled.p`
  color: var(--Dark-1, #6C6559);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  @media screen and (max-width: 400px) {
    font-size: 14px;
  }
`

export const ChangeBtn = styled.div`
  background: var(--PrimaryGradient, linear-gradient(90deg, #D39118 0%, #FFCB43 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 26px;
  width: 60px;
  font-size: 14px;
`

export const SSWarningText = styled.div`
  color: var(--Green, #23AB41);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`